// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const authSsoApiAuthCallbackGetParamsCodeOneMax = 4096;

export const authSsoApiAuthCallbackGetParamsStateOneMax = 200;

export const authSsoApiAuthCallbackGetParamsErrorOneMax = 200;

export const AuthSsoApiAuthCallbackGetParams = zod.object({
  "code": zod.union([zod.string().max(authSsoApiAuthCallbackGetParamsCodeOneMax),zod.null()]).optional(),
  "state": zod.union([zod.string().max(authSsoApiAuthCallbackGetParamsStateOneMax),zod.null()]).optional(),
  "error": zod.union([zod.string().max(authSsoApiAuthCallbackGetParamsErrorOneMax),zod.null()]).optional()
})

export type AuthSsoApiAuthCallbackGetParams = zod.input<typeof AuthSsoApiAuthCallbackGetParams>;
export type AuthSsoApiAuthCallbackGetParamsOutput = zod.output<typeof AuthSsoApiAuthCallbackGetParams>;
